<template>
    <div class="card">
        <div class="card-header">
            <div class="row justify-content-between">
                <div class="col-auto px-1">
                    <SearchLegalEntity/>
                </div>
            </div>
        </div>
        <div class="card-body py-0 px-1">
            <TableLegalEntity></TableLegalEntity>
        </div>
    </div>
</template>

<script>
import SearchLegalEntity from "@/components/ManagedCompanies/ShareholdersStructure/LegalEntitiesList/Search-legal-entity.vue";
import TableLegalEntity from "@/components/ManagedCompanies/ShareholdersStructure/LegalEntitiesList/Table-legal-entity.vue";

export default {
    name: 'LegalEntitiesList',

    components: {
        TableLegalEntity,
        SearchLegalEntity,
    }
}
</script>
<style scoped>
</style>
